import { render, staticRenderFns } from "./ProductReleasedWarehouseList.vue?vue&type=template&id=126d41d5&scoped=true&"
import script from "./ProductReleasedWarehouseList.vue?vue&type=script&lang=js&"
export * from "./ProductReleasedWarehouseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126d41d5",
  null
  
)

export default component.exports